import React from 'react';
import styled from '@emotion/styled';
import Tooltip from '@unicons-base/Tooltip/Tooltip';
import { PLAYER_Z_INDEX } from '@unicons-constants/style.constants';
import { Fonts } from '@styles/index';

interface ControlButtonProps {
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  children: React.ReactNode;
  marginRight?: string;
  tooltipTitle?: string;
}

type ControlButtonType = {
  $marginRight?: string;
};

const StyledControlButton = styled.button<ControlButtonType>`
  z-index: ${PLAYER_Z_INDEX.BUTTON};
  font-size: 1.2rem !important;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 5px 2px;
  margin-right: ${({ $marginRight }) => $marginRight || '0px'};
  &:hover {
    background: var(--color-i-icon-dark-supporting) !important;
    border-radius: 100%;
  }
`;

const StyledTooltip = styled(Tooltip)`
  & .MuiTooltip-tooltip {
    background-color: white;
    color: var(--color-i-icon-dark-button);
    text-transform: uppercase;
    font-weight: ${Fonts.BOLD};
  }
`;

const ControlButton: React.FC<ControlButtonProps> = React.forwardRef<
  HTMLButtonElement,
  ControlButtonProps
>(({ onClick, children, className, marginRight, tooltipTitle }, ref) => {
  return (
    <StyledTooltip title={tooltipTitle}>
      <StyledControlButton
        type="button"
        ref={ref}
        $marginRight={marginRight}
        className={className}
        onClick={onClick}
      >
        {children}
      </StyledControlButton>
    </StyledTooltip>
  );
});

ControlButton.displayName = 'ControlButton';

ControlButton.defaultProps = {
  onClick: () => {},
  tooltipTitle: ''
};

export default ControlButton;
